import React from 'react';
import SVG from 'react-inlinesvg';
import { copyFor } from 'config';
import Play from '/images/icons/play.svg';
import WindTurbines from '/images/usage-page/windturbines.png';
import { Container, Hr } from 'styles';
import { PlaySVG, ImageLink, TextLink } from './video-links.style';

const getCopy = copyFor('usage.recs');
export const href = 'https://www.youtube.com/watch?v=_12VYXms6-c';

export const VideoLinks = () => (
  <Container flex direction="column" alignItems="center">
    <ImageLink
      aria-label={getCopy('links.watchVideo')}
      href={href}
      withPadding={false}
    >
      <img src={WindTurbines} />
      <PlaySVG src={Play} width="14%" />
    </ImageLink>
    <Container margin={{ bottom: '8px' }} />
    <TextLink id="textText" href={href} type="standalone" hideIcon={true}>
      <Container
        alignItems="center"
        flex
        justifyContent="space-between"
        margin={{ bottom: '24px', left: '2px', right: '2px', top: '24px' }}
      >
        {getCopy('links.watchVideo')}
        <SVG src={Play} width="24px" />
      </Container>
    </TextLink>
    <Hr margin={{ bottom: '24px' }} />
  </Container>
);
